import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, LogIn } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: ""
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.get(`${API}/admin/verify`, {
        auth: {
          username: credentials.username,
          password: credentials.password
        }
      });

      if (response.data.authenticated) {
        // Store credentials in sessionStorage
        sessionStorage.setItem('adminAuth', btoa(`${credentials.username}:${credentials.password}`));
        toast.success("Ingelogd!");
        navigate('/admin/dashboard');
      }
    } catch (error) {
      toast.error("Ongeldige inloggegevens");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-page min-h-screen flex items-center justify-center p-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="admin-surface p-8 lg:p-10">
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-[#3d56a6]/10 to-[#f2a100]/14 flex items-center justify-center border border-[#3d56a6]/10">
              <Lock className="w-8 h-8 text-[#3d56a6]" />
            </div>
            <h1 className="text-2xl font-bold text-[#16224b]">Admin Panel</h1>
            <p className="text-[#6b7184] mt-2">Log in om content te beheren</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-[#16224b]">Gebruikersnaam</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9aa3b8]" />
                <Input
                  id="username"
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  required
                  className="admin-input pl-10"
                  placeholder="admin"
                  data-testid="admin-username"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#16224b]">Wachtwoord</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9aa3b8]" />
                <Input
                  id="password"
                  type="password"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  required
                  className="admin-input pl-10"
                  placeholder="••••••••"
                  data-testid="admin-password"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full btn-primary"
              data-testid="admin-login-btn"
            >
              {isLoading ? "Inloggen..." : (
                <>
                  <LogIn className="w-5 h-5 mr-2" />
                  Inloggen
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
